// 找到tree的所有父级

export const findTreeParent = (data, fn, children = "children") => {
  let result = [];
  const a = (data, fn) => {
    return data.some((item, index) => {
      if (index > 0) {
        let f = result.findIndex(v => v === data[index - 1]);
        ~f && (result = result.slice(0, f));
      }
      if (fn(item, index)) {
        result.push(item);
        return true;
      } else {
        if (item[children]) {
          result.push(item);
          return a(item[children], fn);
        } else {
          return false;
        }
      }
    });
  };
  a(data, fn);
  return result;
};
